/*
  Chrome and Safari will scroll (without a scrollbar UI) an overflow:hidden
  element if a descendant that is not fully visible receives focus.

  This is not desirable when the focused elements are supposed to be visibly
  cropped by the edge of the container.

  We can prevent this by resetting the scroll position to zero on focus.
*/

document.addEventListener('DOMContentLoaded', init);

export default function init() {
  Array.from(document.querySelectorAll('.no-overflow-scroll')).forEach(preventOverflowScroll);
}

function preventOverflowScroll(el) {
  const useCapture = true; // focus doesn’t bubble
  el.addEventListener('focus', resetScrollFor(el), useCapture);
}

function resetScrollFor(el) {
  const doReset = function() {
    el.scrollTop = 0;
  };

  return function() {
    doReset(); // works in Chrome
    setTimeout(doReset, 0); // necessary in Safari but can flicker :(
  };
}
